import script from "./SectionListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionListItem.vue?vue&type=script&setup=true&lang=js"

import "./SectionListItem.vue?vue&type=style&index=0&id=41980026&lang=less"

const __exports__ = script;

export default __exports__